// Vanilla CSS for PageTravelGroup. Prefix: ptg-. Aggregated into libraryStyles.
// Playful Frost glass pager: circular glass prev/next buttons, a glass page
// indicator pill, and an optional compact glass jump-to-page field.
export const pageTravelGroupStyles = `
  .ptg-row {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--space-3);
  }
  .ptg-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: var(--rad-catchup-full);
    border: 1px solid var(--glass-flat-border);
    /* Solid (no blur) — pager controls sit under every scrolling list;
       blur only frosts the flat page bg (pure raster cost). */
    background: var(--glass-flat-solid);
    color: var(--brand-dark);
    cursor: pointer;
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
    transition: transform var(--duration-base) var(--ease-glass),
      box-shadow var(--duration-base) var(--ease-glass),
      border-color var(--duration-base) var(--ease-glass);
  }
  .ptg-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    border-color: var(--brand-dark);
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-hover);
  }
  .ptg-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  .ptg-btn svg { display: block; }

  .ptg-count {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
    padding: 7px 18px;
    border-radius: var(--rad-catchup-full);
    /* Solid (no blur) — pager controls sit under every scrolling list;
       blur only frosts the flat page bg (pure raster cost). */
    background: var(--glass-flat-solid);
    border: 1px solid var(--glass-flat-border);
    box-shadow: var(--glass-flat-edge);
    font-size: var(--fs-md);
    font-weight: 700;
  }
  .ptg-count-cur {
    font-size: var(--fs-lg);
    font-weight: 800;
    color: var(--brand-darker);
  }
  .ptg-count-sep { color: var(--text-muted); }
  .ptg-count-total { color: var(--text-secondary); }

  .ptg-input {
    width: 64px;
    padding: 8px 12px;
    text-align: center;
    font-family: var(--font-sans);
    font-size: var(--fs-md);
    font-weight: 700;
    color: var(--brand-darker);
    border: 1px solid var(--glass-flat-border);
    border-radius: var(--rad-catchup-full);
    /* Solid (no blur) — pager controls sit under every scrolling list;
       blur only frosts the flat page bg (pure raster cost). */
    background: var(--glass-flat-solid);
    -moz-appearance: textfield;
    appearance: textfield;
  }
  .ptg-input::-webkit-outer-spin-button,
  .ptg-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .ptg-input:focus {
    outline: none;
    border-color: #54bbcb;
    box-shadow: 0 0 0 3px rgba(87, 194, 211, 0.18);
  }
`;
